import bronze from "../images/bronze.png";
import silver from "../images/silver.png";
import gold from "../images/gold.png";
import platinum from "../images/platinum.png";

const FoundersCircle = () => {
  const tiers = [
    {
      name: "Bronze Founders",
      image: bronze,
      bgColor: "bg-[#fad8c2]",
      price: "$1,000",
      benefits: [
        {
          title: "Regional PR campaign recognition",
          description:
            "Founders' Circle logo placement during the 'It's Time' PR campaign.",
        },
        {
          title: "Logo on Founders Circle page",
          description: "Logo displayed on the Founders' Circle page.",
        },
        {
          title: "Sponsorship plaque",
          description:
            "Receive a plaque as a token of appreciation for your sponsorship.",
        },
        {
          title: "2 VIP Seating",
          description: "Reserved seats at exclusive IEJL events.",
        },
      ],
    },
    {
      name: "Silver Founders",
      image: silver,
      bgColor: "bg-[#fad8c2]",
      price: "$5,001",
      extra: "Everything in Bronze, plus:",
      benefits: [
        {
          title: "Social media promotion",
          description: "Logo featured in event promotion posts.",
        },
        {
          title: "Event email marketing",
          description:
            "Logo placement in email blasts for selected programs and events.",
        },
        {
          title: "6 VIP Seating",
          description: "Reserved seats at exclusive IEJL events.",
        },
      ],
    },
    {
      name: "Gold Founders",
      image: gold,
      bgColor: "bg-[#fad8c2]",
      price: "$15,001",
      extra: "Everything in Silver, plus:",
      benefits: [
        {
          title: "National PR campaign recognition",
          description: "Logo placement in the national 'It's Time' campaign.",
        },
        {
          title: "Logo on IEJL landing page",
          description:
            "Logo placement on the IEJL landing page for the current and next year.",
        },
        {
          title: "Monthly newsletter ads",
          description:
            "Logo placement and a 1/4-page advertisement in monthly newsletters.",
        },
        {
          title: "10 VIP Seating",
          description: "Reserved seats at exclusive IEJL events.",
        },
      ],
    },
    {
      name: "Platinum Founders",
      image: platinum,
      bgColor: "bg-[#fad8c2]",
      price: "$25,000",
      extra: "Everything in Gold, plus:",
      benefits: [
        {
          title: "Event marketing collateral",
          description:
            "Logo placement at all IEJL events and programs for the current and next year.",
        },
        {
          title: "10 VIP Seating",
          description: "Reserved seats at exclusive IEJL events.",
        },
      ],
    },
  ];

  return (
    <section id="foundersTier" className="bg-[#e5edf6] w-full py-12">
      <div className="flex justify-center w-full">
        <div className="max-w-screen-xl w-full">
          <div className="rounded-lg shadow-lg p-6">
            <h2 className="text-3xl font-medium text-black text-left mb-8 font-raleway md:ml-12">
              Founders’ Circle Benefits
            </h2>
            <div className="flex flex-wrap gap-6 justify-center">
              {tiers.map((tier, index) => (
                <div
                  key={index}
                  className={`w-full md:w-[270px] ${tier.bgColor} rounded-lg p-4 shadow-md`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-xl font-medium flex items-center gap-2 font-raleway">
                      {tier.name}
                      <img
                        src={tier.image}
                        alt={tier.name}
                        className="w-12 h-12 rounded-full"
                      />
                    </h3>
                  </div>
                  <span className="text-sm text-gray-600 block mb-2">
                    Starting at {tier.price}
                  </span>
                  {tier.extra && (
                    <p className="text-sm text-gray-700">
                      {tier.extra}{" "}
                      <span className="text-xl text-[#ff6700]">plus:</span>
                    </p>
                  )}
                  <ul className="mt-2 space-y-2 text-sm text-gray-700">
                    {tier.benefits.map((benefit, i) => (
                      <li
                        key={i}
                        className="text-sm font-medium text-gray-900 block"
                      >
                        {benefit.title}
                        <span className="text-xs text-gray-600 block font-light">
                          {benefit.description}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersCircle;
